import React from 'react';

import {
  Card,
  Content,
  FileIcon,
  FileInfo,
  FileName,
  FileSize,
  ProgressInfo,
  ProgressWrapper,
  FileDetail,
  FileType
} from './styles';
import FileSVGIcon from '../../assets/images/svg/filesIconSvg';
import { FILE_EXTENSIONS } from '../../global/constants';
import ProgressBar from '../progressBar';
interface FileUploadCardProps {
  progress: number;
  fileSize: string | number;
  extension: string;
  fileName: string;
}

const FileUploadCard: React.FC<FileUploadCardProps> = ({ fileName, progress, fileSize, extension }) => {
  const isCustomExtension = !FILE_EXTENSIONS.includes(extension);
  if (!progress) return <></>;
  return (
    <Card>
      <Content>
        <FileDetail>
          {isCustomExtension ? (
            <FileIcon>
              <FileSVGIcon name={'blank'} height='32' width='32' viewBox='0 0 60 60' />
              <FileType fontSize={extension?.length === 5 ? 5 : 6} className='upload-file-text'>
                {extension?.split('.')?.pop()?.toUpperCase()}
              </FileType>
            </FileIcon>
          ) : (
            <FileSVGIcon name={extension} height='32' width='32' viewBox='0 0 60 60' />
          )}
          <FileInfo>
            <FileName>{fileName}</FileName>
            {fileSize !== 0 && <FileSize>{fileSize}</FileSize>}
          </FileInfo>
        </FileDetail>
        <ProgressInfo>{Math.round(progress)}%</ProgressInfo>
      </Content>
      <ProgressWrapper>
        <ProgressBar percent={Math.round(progress)} progressColor='var(--brand-primary)' showInfo={false} height={3} />
      </ProgressWrapper>
    </Card>
  );
};

export default FileUploadCard;
